interface PageErrorProps {
  errorTitle: string;
  errorMessage: string | JSX.Element;
}

export default function PageError({
  errorTitle,
  errorMessage,
}: PageErrorProps) {
  return (
    <div className="flex h-full min-h-svh flex-col items-center justify-center text-center">
      <div className="max-w-md space-y-6 px-4">
        <div className="space-y-2 uppercase">
          <h1 className="text-6xl font-extrabold">Oops!</h1>
          <h3 className="text-nowrap text-2xl font-bold text-warning">
            {errorTitle}
          </h3>
        </div>
        <p>{errorMessage}</p>
      </div>
    </div>
  );
}
